/*
 * @Author: cq
 * @LastEditors: cq
 * @Date: 2025-03-24 16:32:36
 * @LastEditTime: 2025-06-06 10:29:38
 * @FilePath: \point-cloud-analysis\page\api\pointcloud.js
 */

/**
 * 点云分析相关服务模块
 * 使用request工具类和API配置进行点云相关操作
 */

import { get, post, del, upload } from './api.js';
import { POINT_CLOUD_API } from './config.js';

import * as THREE from "../../libs/three.js/build/three.module.js";




/**
 * 上传文件之前先搜索该文件是否已经上传过
 * @param {String} fileMd5 - 文件的MD5哈希值
 * @param {String} fileName - 文件名称
 */
function findFileStatusByMd5(fileMd5, fileName) {
  return get(POINT_CLOUD_API.FIND_UPLOAD_STATUE, { fileMd5, fileName });
}

/**
 * 上传点云数据
 * @param {File} file - 点云文件对象
 * @returns {Promise} - 返回Promise对象
 */
export function uploadPointCloud(file) {
  const formData = new FormData();
  formData.append('file', file);
  return upload(POINT_CLOUD_API.UPLOAD, formData);
}
/**
 * 分片上传点云数据，使用 MD5 生成文件唯一标识符
 * @param {File} file - 点云文件对象
 * @param {Number} chunkSize - 每个分片的大小（字节）默认为50MB
 * @returns {Promise} - 返回Promise对象
 */
export async function uploadPointCloudInChunks(file, chunkSize = 50 * 1024 * 1024) {
  if (!(file instanceof File)) {
    throw new TypeError('The provided file is not a valid File object.');
  }
  // 获取元素
  const uploadStatus = document.getElementById('upload-status');
  const progressAllProgress = document.getElementById('progress-all-progress');
  const progressBar0 = document.getElementById('progress-bar-0');
  const progressBar1 = document.getElementById('progress-bar-1');
  const progressBar2 = document.getElementById('progress-bar-2');

  const uploadLabel = document.getElementById('upload-label');

  // 开始前要重置所有的进度
  progressBar0.setAttribute('width', `0%`);
  progressBar1.setAttribute('width', `0%`);
  progressBar2.setAttribute('width', `0%`);
  progressAllProgress.textContent = `0%`;

  // 生成文件的 MD5 哈希值
  const fileHash = await calculateFileMD5WithProgress(file);
  // console.log('File MD5 Hash:', fileHash);

  // 查询文件上传状态
  const response = await findFileStatusByMd5(fileHash, file.name);
  if (response.code !== 200) {
    viewer.postError(response.msg || "查询文件状态失败");
    return;
  }
  const fileStatus = response.data.status;
  const cacheList = response.data.cacheList || []; // 已上传切片序号数组
  // status: 1 秒传   2 已上传部分分片   0 未上传  
  if (fileStatus === "1") {
    console.log("文件已上传");
    // 更新上部进度条
    uploadStatus.textContent = "秒传";
    // 更新上传进度条
    progressBar1.setAttribute('width', `100%`);
    progressBar2.setAttribute('width', `100%`);
    // 总进度
    progressAllProgress.textContent = `100%`;

    uploadStatus.textContent = "渲染完成";
    // loadPointCloud("/api" + response.data.fileUrl, response.data.fileName)
    let scene = viewer.scene;
    // 发送事件
    scene.loadPointCloud(response.data)
    uploadLabel.style.display = "flex";
    return response; // 文件已上传
  }

  const totalChunks = Math.ceil(file.size / chunkSize);
  const uploadResults = []; // 存储每个切片的上传结果
  const failedChunks = []; // 存储上传失败的切片索引
  let uploadedChunks = cacheList.length; // 已上传的切片数量

  uploadStatus.textContent = "准备上传...";

  // 开始时间
  const startTime = Date.now();

  console.log("开始上传时间:", startTime);
  // 上传切片开始之后就要建立 SSE 连接
  const eventSource = new EventSource(`${POINT_CLOUD_API.SSE_ANALYZE}${fileHash}`);

  eventSource.onmessage = (event) => {
    let info = JSON.parse(event.data);
    // console.log("SSE Message:", info);
    // 更新第三个进度条
    progressBar2.setAttribute('width', `${info.progress}%`);
    uploadStatus.textContent = `渲染中...${info.progress}%`;
    progressAllProgress.textContent = `${(info.progress * 0.33 + 66).toFixed(2)}%`;
    // 后端点云切片完成,得到fileUrl
    // // status: 5 后端点云切片中  6 切片完成（url）
    if (info.status === "6" && info.fileUrl) {
      uploadStatus.textContent = "渲染完成";
      // 总进度
      progressAllProgress.textContent = `100%`;
      // loadPointCloud("/api" + info.fileUrl, info.fileName);
      let scene = viewer.scene;
      // 发送事件
      scene.loadPointCloud(info)

      uploadLabel.style.display = "flex";

      return event;
    }
  };
  eventSource.onerror = (error) => {
    console.error("SSE Error:", error);
    eventSource.close();
  };


  // 开始切片
  for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {

    if (!cacheList.includes(chunkIndex)) {
      const start = chunkIndex * chunkSize;
      const end = Math.min(file.size, start + chunkSize);
      const chunk = file.slice(start, end);

      const formData = new FormData();
      formData.append('file', chunk);
      formData.append('chunkIndex', chunkIndex);
      formData.append('chunks', totalChunks);
      formData.append('fileName', file.name);
      formData.append('fileMd5', fileHash);

      // 创建上传任务
      const uploadTask = upload(POINT_CLOUD_API.FRAGMENT_UPLOAD, formData)
        .then((uploadResponse) => {
          console.log(`Chunk ${chunkIndex} uploaded successfully:`, uploadResponse.data);
          uploadResults.push({ chunkIndex, result: uploadResponse.data });
          // status:   3 上传未结束  4 完成上传 
          uploadedChunks++;
          // 更新第二个进度条
          const progress = (uploadedChunks / totalChunks * 100).toFixed(2);
          // console.log(`Upload progress:`, progress);

          if (progressBar1) {
            progressBar1.setAttribute('width', `${progress}%`);
            uploadStatus.textContent = `上传中...${progress}%`;
            if (Math.abs(parseFloat(progress) - 100) <= 0.01) {
              uploadStatus.textContent = "准备渲染...";
            }
            progressAllProgress.textContent = `${((progress * 0.33 + 33).toFixed(2))}%`;
          }
        })
        .catch((error) => {
          viewer.postError("点云文件上传失败");
          console.error(`Error uploading chunk ${chunkIndex}:`, error);
          failedChunks.push(chunkIndex); // 记录失败的切片索引
        });

      await uploadTask;
    }
  }

  // 结束事件
  const endTime = Date.now();
  console.log("结束上传时间:", endTime);

  // 时间差
  const duration = endTime - startTime;
  console.log("上传耗时:", duration);


  // 如果有失败的切片，记录日志并返回失败信息
  if (failedChunks.length > 0) {
    console.warn(`Failed chunks: ${failedChunks.join(', ')}`);
  }

  // 检查是否所有切片上传完成
  const finalResponse = uploadResults.find((result) => result.result.status === "4");
  if (finalResponse) {
    return finalResponse.result; // 所有切片上传完成
  }

}
/* 计算文件的 MD5 哈希值
* @param {File} file - 文件对象
* @returns {Promise<String>} - 返回文件的 MD5 哈希值
*/
async function calculateFileMD5WithProgress(file) {
  return new Promise((resolve, reject) => {
    const chunkSize = 4 * 1024 * 1024; // 每次读取 4MB
    const chunks = Math.ceil(file.size / chunkSize);
    const spark = new SparkMD5();
    const fileReader = new FileReader();
    let currentChunk = 0;

    // 获取进度条元素
    const uploadStatus = document.getElementById('upload-status');

    const progressBar0 = document.getElementById('progress-bar-0');
    const progressAllProgress = document.getElementById('progress-all-progress');

    // progressCircle.setAttribute("transition", "stroke-dasharray 0.3s ease-in-out");
    fileReader.onload = (e) => {
      spark.append(e.target.result);
      currentChunk++;
      const progress = (currentChunk / chunks * 100).toFixed(2);
      // console.log(`Upload progress: ${progress}% ${(progress * 0.33).toFixed(2)}`);
      // 更新第一个进度条进度
      if (progressBar0) {
        uploadStatus.textContent = `解析中...${progress}%`;
        progressBar0.setAttribute('width', `${progress}%`);
        // 总进度
        progressAllProgress.textContent = `${(progress * 0.33).toFixed(2)}%`;


      }

      if (currentChunk < chunks) {
        loadNextChunk();
      } else {
        resolve(spark.end());
      }
    };

    fileReader.onerror = (err) => {
      reject(err);
    };

    function loadNextChunk() {
      const start = currentChunk * chunkSize;
      const end = Math.min(file.size, start + chunkSize);
      fileReader.readAsArrayBuffer(file.slice(start, end));
    }

    loadNextChunk();
  });
}
// 加载指定的点云文件
export function loadPointCloud(url, pointCloudName = "", md5 = "", handle = null, isJump = true) {
  // 加载点云
  Potree.loadPointCloud(url, pointCloudName, e => {
    let scene = viewer.scene;
    let pointcloud = e.pointcloud;
    // 保存文件md5值
    pointcloud.md5 = md5;
    // 点云是否已经被处理了
    pointcloud.handle = handle;

    let material = pointcloud.material;
    // 点大小类型为自适应
    material.pointSizeType = Potree.PointSizeType.ADAPTIVE;
    material.size = 0.1                 // 设置点的大小
    // material.weightRGB = 1.0;            // RGB 权重
    material.weightElevation = 1.0;      // 高程权重
    material.activeAttributeName = "elevation";

    scene.addPointCloud(pointcloud);

    // viewer.fitToScreen();

    if (isJump || isJump === undefined) {
      console.log("跳转到点云", isJump);

      // 获取点云的包围盒
      let box = viewer.getBoundingBox([pointcloud]);
      // 创建一个空节点并设置包围盒
      let node = new THREE.Object3D();
      node.boundingBox = box;
      /**
       * - node : 要聚焦的目标对象
       * - 1 : 缩放系数，1 表示刚好完整显示对象
       * - 500 : 动画持续时间（毫秒），这里是 0.5 秒
       */
      viewer.zoomTo(node, 1, 500);
    }

  });


}


/**
 * 处理点云数据
 * 
 * @returns {Promise} - 返回Promise对象
 */
export async function pointCloudHandle(fileName, fileMd5) {
  const formData = new FormData();
  formData.append('fileName', fileName);
  formData.append('fileMd5', fileMd5);
  return post(POINT_CLOUD_API.POINT_CLOUD_HANDLE, formData);
}

export async function exportVector(fileName, fileMd5) {
  const formData = new FormData();
  formData.append('fileName', fileName);
  formData.append('fileMd5', fileMd5);
  return post(POINT_CLOUD_API.EXTRACT_VECTOR, formData);
}

/**
 * 获取点云数据列表
 * 
 * @returns {Promise} - 返回Promise对象
 */
export async function getPointCloudList(data) {
  return get(POINT_CLOUD_API.POINT_CLOUD_LIST, data);
}

/**
 * 获取单个点云数据详情
 * @param {String} id - 点云数据ID
 * @returns {Promise} - 返回Promise对象
 */
export function getPointCloudDetail(id) {
  return get(POINT_CLOUD_API.GET_BY_ID, { id });
}

/**
 * 删除点云数据
 * @param {String} id - 点云数据ID
 * @returns {Promise} - 返回Promise对象
 */
export function deletePointCloud(id) {
  return del(POINT_CLOUD_API.DELETE, { id });
}

/**
 * 分析点云数据
 * @param {String} id - 点云数据ID
 * @param {Object} options - 分析选项
 * @returns {Promise} - 返回Promise对象
 */
export function analyzePointCloud(id, options = {}) {
  return post(POINT_CLOUD_API.ANALYZE, { id, ...options });
}

/**
 * 导出点云分析结果
 * @param {String} id - 点云数据或分析任务ID
 * @param {String} format - 导出格式，如'csv', 'json'等
 * @returns {Promise} - 返回Promise对象
 */
export function exportAnalysisResult(id, format = 'csv') {
  return get(POINT_CLOUD_API.EXPORT_RESULT, { id, format });
}

export default {
  uploadPointCloud,
  loadPointCloud,
  uploadPointCloudInChunks,
  calculateFileMD5WithProgress,
  getPointCloudList,
  getPointCloudDetail,
  deletePointCloud,
  analyzePointCloud,
  exportAnalysisResult,
  pointCloudHandle
};